"use client";

import React from "react";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";

import CourseSection from "./course-section";

function CourseFaq({ faqs = [] }) {
  const [isExpanded, setIsExpanded] = React.useState(false);

  if (!faqs.length) return null;

  const handleOnFaqToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  const finalFaqs = isExpanded ? faqs : faqs.slice(0, 5);

  return (
    <CourseSection id="course-faqs" title="Frequently Asked Questions">
      <Accordion
        type="single"
        className="space-y-3"
        defaultValue="course-faq-0"
        collapsible
      >
        {finalFaqs.map((faq, index) => (
          <AccordionItem
            key={faq.question}
            value={`course-faq-${index}`}
            className="!border border-grayscale-line rounded-xl overflow-hidden"
          >
            <AccordionTrigger className="bg-grayscale-weak text-grayscale-header-weak py-4 px-6 hover:no-underline">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-grayscale-label border-t border-grayscale-line px-6 pt-4.5 pb-3.5">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      {faqs.length > 5 && (
        <div className="flex justify-center mt-2">
          <Button variant="ghost" size="small" onClick={handleOnFaqToggle}>
            Show {isExpanded ? "Less" : "More"} FAQs
          </Button>
        </div>
      )}
    </CourseSection>
  );
}

export default CourseFaq;
